import React from 'react';

import Live from '@/presentation/screens/live';

import { CurrentLessonHeader } from '../current-lesson-header';

interface LessonPlayerProps {
  mobileSidebarOpen: boolean;
  title: string;
  onClose: () => void;
}

interface LessonStreamingPlayerProps {
  courseGuid: string;
  streamingGuid: string;
}

export const LivePlayerContainer = ({
  mobileSidebarOpen,
  title,
  onClose,
  courseGuid,
  streamingGuid,
}: LessonPlayerProps & LessonStreamingPlayerProps) => (
  <div className={`current-lesson ${mobileSidebarOpen ? 'hidden' : ''}`}>
    <CurrentLessonHeader title={title} onClose={onClose} />

    <Live courseGuid={courseGuid} streamingGuid={streamingGuid} />
  </div>
);
